<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.generalInfo}}</h4>
            <form @keyup.enter="onSubmit" class="text-left">
                <h3 class="text-center text-danger mb-3" v-if="errorMsg">{{ errorMsg }}</h3>
                <div class="px-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <Input :icon="icons.typePack"
                                   :inputKey="'label'"
                                   :name="titles.placeholderNameTypePack"
                                   :validate="$v.typePack.label"
                                   @method="getValue"
                            />
                            <div class="col-lg-6">
                                <CheckBox :inputKey="'enabled'" :name="titles.active" :validate="enabled"
                                          @method="getValue"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-4 text-right">
                    <button
                            :disabled="isLoading"
                            @click="onSubmit"
                            class="btn btn-standard-gradient px-5"
                            type="button"
                            v-if="isEditable"
                    >
                        <b-spinner label="Spinning" small v-if="isLoading"></b-spinner>
                        {{name_btn}}
                    </button>
                    <modal-success @messageFromModal="closeModal" id="success-typePack"
                                   title="Type de pack ajouté avec succès"/>
                    <modal-success @messageFromModal="closeModal" id="success-edit-typePack"
                                   title="Type de pack modifié avec succès"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {
        addTypePack,
        getAllTypePacks,
        updateTypePack
    } from '../../shared/services/typePack.service';
    import {
        minLength,
        required
    } from 'vuelidate/lib/validators';
    import ModalSuccess from '../../common/modal-success';
    import {titles} from '../../../utils/general/titles';
    import {typePack} from '../../shared/models/typePack';
    import {icons} from '../../../utils/general/icons';
    import Input from '@/components/common/Input.vue';
    import {name} from '../../../utils/general/routers';
    import CheckBox from '../../common/CheckBox';
    import {errorMixin} from '../../../utils/errorMixin';

    export default {
        name: 'InfosTypePack',
        components: {ModalSuccess, Input, CheckBox},
        data() {
            return {
                titles,
                icons,
                isLoading: false,
                errorMsg: '',
                typePack: typePack(),
                isEditable: true,
                name_btn: titles.add,
                title: titles.typePackAddExpression,
                enabled: false,
                items: []
            };
        },
        created() {

            if (this.$cookies.isKey('typePackItems')) {
                this.items = JSON.parse(this.$cookies.get('typePackItems'));
            } else {
                this.fetchTypePacks();
            }

            if (this.$route.params.typePackItem) {
                this.$cookies.set('typePackItem', this.$route.params.typePackItem);
                this.$cookies.set('typePackItemIsEditable', this.$route.params.isEditable);
            }
            if (this.$cookies.isKey('typePackItem')) {
                this.typePack = this.$cookies.get('typePackItem');
                this.isEditable = this.$cookies.get('typePackItemIsEditable');
                this.title = titles.typePackEditExpression;
                this.name_btn = titles.update;
                this.enabled = this.typePack.enabled;
            } else {
                this.typePack.packOrder = this.$route.params.maxId + 1;
            }
        },
        mixins: [errorMixin],
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.errorMsg = null;
                this.isLoading = true;
                this.typePack = typePack(this.typePack);
                if (this.$cookies.isKey('typePackItem') == false) {
                    addTypePack(this.typePack).then(
                        response => {
                            this.typePack.id = response.data.id;
                            this.$emit('getTypePack', this.typePack);
                            this.$bvModal.show('success-typePack');
                            this.isLoading = false;
                        },
                        error => {
                            this.showError(error);
                        }
                    );
                } else {
                    updateTypePack(this.typePack.id, this.typePack).then(
                        response => {
                            this.typePack.id = response.data.id;
                            this.$emit('getTypePack', this.typePack);
                            this.$bvModal.show('success-edit-typePack');
                            this.isLoading = false;
                            return response;
                        },
                        error => {
                            this.showError(error);
                        }
                    );
                }
            },
            closeModal() {
                this.$cookies.remove('typePackItem');
                this.$cookies.remove('typePackItemIsEditable');
                this.$router.push({name: name.typePackList});
            },
            getValue(inputKey, val) {
                this.$v.typePack[inputKey].$touch();
                this.typePack[inputKey] = val;

            },
            async fetchTypePacks(column, val, type) {
                if (column) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        column,
                        val,
                        type
                    );
                }
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'deleted',
                    '0',
                    null
                );
                this.orderQueryGenerator('packOrder', false);
                getAllTypePacks(
                    this.filterQuery, this.sort
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.items = this.items.map(
                        function (item) {
                            return typePack(item);
                        }
                    );
                    this.hasValue = false;
                    if (this.items.length > 0) {
                        this.maxId = this.items.reduce(
                            (max, item) => (item.packOrder > max ? item.packOrder : max),
                            this.items[0].packOrder
                        );
                        this.hasValue = true;
                    }
                    this.$cookies.set('typePackItems', JSON.stringify(this.items));
                    this.rows = response.data['hydra:totalItems'];
                    this.inProgess = false;
                });
            }
        },
        validations: {
            typePack: {
                label: {
                    required,
                    minLength: minLength(3),
                    checkExistLabel(label) {
                        if (label != null) {
                            const existItem = this.items.find(item => item.label.toLowerCase() == label.toLowerCase());
                            if (this.$cookies.isKey('typePackItem') && existItem != undefined &&
                                this.typePack.id == existItem.id) {
                                return true;
                            }
                            return existItem == undefined;
                        }
                        return true;
                    }
                },
                enabled: {
                    required
                }
            }
        }
    };
</script>

<style scoped>

</style>
